import { render, staticRenderFns } from "./TextLabelButton.vue?vue&type=template&id=4466decc&scoped=true&"
import script from "./TextLabelButton.vue?vue&type=script&lang=js&"
export * from "./TextLabelButton.vue?vue&type=script&lang=js&"
import style0 from "./TextLabelButton.vue?vue&type=style&index=0&id=4466decc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466decc",
  null
  
)

export default component.exports